module.exports = __webpack_public_path__ + "img/print-pti.ca2eceb8.svg";